export default __webpack_public_path__ + "static/media/logo.abf2c713.svg";